// extracted by mini-css-extract-plugin
module.exports = {"balance_option":"styles_balance_option__1R7md","balance_option_label":"styles_balance_option_label__378Ms","balance_option_price":"styles_balance_option_price__76r81"};